import styled from 'styled-components'

export const Name = styled.h3`
  font-size: 22px;
  line-height: 26px;
  font-weight: 500;
  margin: 0px;
  text-align: left;
  max-width: calc(100% - 95px);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;

  @media(min-width: 768px){
    width: auto;
  }
`

export const LockedLabel = styled.div`
  height: 40px;
  border-radius: 24px;
  padding: 0px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  // background: #CFABF2;
  // background: linear-gradient(90deg,rgba(207, 171, 242, .18) 0%, rgba(108, 92, 231, .18) 31%, rgba(66, 178, 252, .18) 100%);
  background-color: #FEF3C6;
  color: #93410F;
  font-size: 16px;
  font-weight: 600;
  gap: 8px;
`

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
`

export const CategoryHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start; 
  gap: 14px;
  width: 100%;
  flex-direction: column;

  @media(min-width: 768px){
    flex-direction: row;
    align-items: center;
    justify-content: space-between; 
  }
`
